import AjaxCommons from '@/services/ajax-commons';
import TranslationApiAgent from '@/services/translation-api-agent';

export interface ProgramResponse {
    id: number;
    datum: number;
    datumig: number;
    content: string;
}

export interface Program {
  id: number;
  from: Date;
  to: Date;
  content: string;
}

export interface GroupedProgram {
  [group: string]: Program[];
}

class NewsApiAgentImpl {
  private months: any = { };

  constructor(private ajax = AjaxCommons, private translationApiAgent = TranslationApiAgent) {}

  public mounted() {
    this.months = {
      1: this.translationApiAgent.get('january'),
      2: this.translationApiAgent.get('february'),
      3: this.translationApiAgent.get('march'),
      4: this.translationApiAgent.get('april'),
      5: this.translationApiAgent.get('may'),
      6: this.translationApiAgent.get('june'),
      7: this.translationApiAgent.get('july'),
      8: this.translationApiAgent.get('august'),
      9: this.translationApiAgent.get('september'),
      10: this.translationApiAgent.get('october'),
      11: this.translationApiAgent.get('november'),
      12: this.translationApiAgent.get('december'),
    };
  }

  public getAll: () => Promise<Program[]> = () => {
    return this.ajax.get('type=programs').then((programs: ProgramResponse[]) => {
      const result = programs.map(p => ({
          id: p.id,
          content: p.content,
          from: new Date(p.datum * 1000),
          to: new Date(p.datumig * 1000),
        }));
      return result.sort(this.sortFn);
    });
  }

  public getAllGrouped: () => Promise<GroupedProgram> = () => {
    return this.getAll().then(this.group);
  }

  public update = (id: string, title: string, from: Date, to: Date) => {
    return this.ajax.post(`type=programs`, {
      id, title,
      from: from.getTime() / 1000,
      to: to.getTime() / 1000,
    }, 'put').then(result => {
      return !!(result && result.result);
    });
  }

  public add = (title: string, from: Date, to: Date) => {
    return this.ajax.post(`type=programs`, {
      title,
      from: from.getTime() / 1000,
      to: to.getTime() / 1000,
    }, 'put');
  }

  public remove = (id: string) => {
    return this.ajax.post(`type=programs`, {
      id,
    }, 'delete');
  }

  private group = (array: Program[]) => {
    const groups: GroupedProgram = {};
    array.forEach(p => {
      const m = p.from.getFullYear() + '. ' + this.months[(p.from.getMonth() + 1)];
      if (!(m in groups)) {
        groups[m] = <Program[]> [];
      }
      groups[m].push(p);
    });
    return groups;
  }

  private sortFn = (a: Program, b: Program) => {
    if (a.from > b.from) {
      return -1;
    }
    if (a.from < b.from) {
      return 1;
    }
    return 0;
  }
}

const NewsApiAgent = new NewsApiAgentImpl();

export default NewsApiAgent;
export { NewsApiAgentImpl };
